<div class="animation-circle"></div>
<div class="content-circle" #clickTarget>
    <mat-icon class="main-icon" svgIcon="upload-custom"></mat-icon>
    <div class="text initial-text">
        <div class="primary" trans>Drop files or folders here</div>
        <div class="secondary" trans>or click to upload.</div>
    </div>
</div>